var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{directives:[{name:"show",rawName:"v-show",value:(!_setup.isHidden),expression:"!isHidden"}],staticClass:"country-flag",style:(_setup.flagStyle),attrs:{"src":_setup.resolvedFlagUrl,"alt":`${_vm.countryCode} flag`},on:{"error":_setup.onImageError}})
}
var staticRenderFns = []

export { render, staticRenderFns }